import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const DispatchBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Dispatch"
      sectionDisplayName="Dispatch Section"
      backRoute="/sections/dispatch"
    />
  );
};

export default DispatchBundleReceiptEntry;
